import React from "react";
import ProfileForm from "../../forms/account/ProfileForm";
import EditSupportContainer from "../../containers/support/EditSupportContainer";
import Modal from "../../components/Modal";
import { useTranslation } from "react-i18next";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const Edit = ({ handleClose, open, profile }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Modal
      fullScreen={matches}
      open={open}
      onClose={handleClose}
      title={t("register.title_edit_profile")}
    >
      {profile ? (
        <EditSupportContainer support={profile}>
          {({ onSubmit, support }) => (
            <ProfileForm onSubmit={onSubmit} initialValues={support} />
          )}
        </EditSupportContainer>
      ) : null}
    </Modal>
  );
};

export default Edit;
